import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ProductionOrderDsService } from '@app/core/data-services';
import { MachineScheduleViewModel, ProductionOrderDeviationEntry, ProductionOrderDeviationProductionSequence, WorkCenter } from 'chronos-core-client';
import { ActiveWorkCenterService, WorkCenterDsService } from '@app/core/workcenter';

@Injectable({
  providedIn: 'root'
})
export class OrderItemService {
  constructor(
    private productionOrderDsService: ProductionOrderDsService,
    private activeWorkCenterService: ActiveWorkCenterService,
    private workCenterDsService: WorkCenterDsService
  ) {}

  public setChecked(id: number, wasReopened: boolean, isChecked: boolean): Observable<void> {
    return this.productionOrderDsService.setCheckedProductionOrder(id, wasReopened, isChecked);
  }

  public presetupProductionOrder(productionOrder: number): Observable<void> {
    return this.productionOrderDsService.presetupProductionOrder(productionOrder);
  }

  public getDeviationProductionSequenceReasons(productionOrderId: number): Observable<ProductionOrderDeviationProductionSequence> {
    return this.productionOrderDsService.getDeviationProductionSequenceReasons(productionOrderId);
  }

  public setNextProductionOrder(productionOrderId: number, showAll: boolean): Observable<MachineScheduleViewModel[]> {
    const workCenterId = this.activeWorkCenterService.getWorkCenterId();
    const entry: ProductionOrderDeviationEntry = {
      workCenterId
    };
    return this.productionOrderDsService
      .setAsNextOrder(productionOrderId, entry)
      .pipe(switchMap(() => this.productionOrderDsService.loadProductionOrderListByShift(showAll)));
  }

  public reopenProductionOrder(productionOrderId: number): Observable<void> {
    return this.productionOrderDsService.reopenProductionOrder(productionOrderId);
  }

  public cancelReopenProductionOrder(productionOrderId: number): Observable<void> {
    return this.productionOrderDsService.cancelReopenProductionOrder(productionOrderId);
  }

  public getWorkCenter(): Observable<WorkCenter> {
    const workCenterId = this.activeWorkCenterService.getWorkCenterId();
    return this.workCenterDsService.getWorkCenter(workCenterId);
  }
}
